import React, { useRef } from 'react';
import styled from 'styled-components';
import compose from 'lodash/fp/compose';
import withCustomerQuestions from '@catalogo/service-americanas-product/src/questions-and-answers/hoc/customer-question';
import { Wrapper } from '@catalogo/theme-wrapper';
import LastQuestions from '@catalogo/ui-americanas-mobile-last-questions';
import withQnA from '@catalogo/service-americanas-product/src/questions-and-answers/hoc/qna';
import QuestionsAndAnswersList from '@catalogo/ui-americanas-mobile-questions-and-answers-list';
import AccordionBox from '@catalogo/ui-americanas-mobile-accordion-box';
import { HasNoQuestions } from './components/has-no-questions.js';
import { MakeQuestions } from './components/make-questions.js';

const Content = styled.div`
  background-color: #fff;
`;

export const QnA = ({
  questionsAndAnswers,
  hasCustomerQuestions,
  hasQuestions,
  fetchMore,
  productId,
  loading,
  customerQuestions,
  hasOffers,
  brandText,
}) => {
  const ref = useRef(null);

  return (
    <AccordionBox
      ref={ref}
      title="Dúvidas sobre o produto"
      shouldGetElementHeightOnRender={false}
      visibilityOnInit={true}
      metricId="q&a"
      id="qna-wrapper"
      anchorRef="#qna-wrapper"
    >
      {!questionsAndAnswers ? null : (
        <Wrapper>
          <Content>
            <MakeQuestions
              hasQuestions={hasQuestions}
              hasOffers={hasOffers}
              hasCustomerQuestions={hasCustomerQuestions}
              titleMakeQuestions={brandText.title.default}
              productId={productId}
            />
            <LastQuestions
              titleCustomerQuestions={brandText.title.customerQuestions}
              customerQuestions={customerQuestions}
              productId={productId}
              hasCustomerQuestions={hasCustomerQuestions}
              hasOffers={hasOffers}
            />
            {!hasQuestions ? (
              <HasNoQuestions
                titleNoQuestions={brandText.title.noQuestions}
                productId={productId}
                hasCustomerQuestions={hasCustomerQuestions}
                hasOffers={hasOffers}
              />
            ) : (
              <QuestionsAndAnswersList
                brandText={brandText}
                questionsAndAnswers={questionsAndAnswers}
                fetchMore={fetchMore}
                productId={productId}
                loading={loading}
                hasOffers={hasOffers}
              />
            )}
          </Content>
        </Wrapper>
      )}
    </AccordionBox>
  );
};

export default compose(withQnA, withCustomerQuestions)(QnA);
